module.exports = __webpack_public_path__ + "img/service_4.b2cbc3f.png";